__turbopack_context__.v({
  "className": "inter_7b064e0d-module__MOT0tq__className",
  "variable": "inter_7b064e0d-module__MOT0tq__variable",
});
